import React from "react";
import { Typography } from "@mui/material";
import contactImage from "../../assets/map.gif";
import {
  AddressContainer,
  AddressContent,
  AddressImage,
} from "../../styles/AddressContainer";
import { Colors } from "../../styles/theme";

export default function ContactBanner() {
  return (
    <>
      <AddressContainer>
        <AddressContent>
          <Typography variant="h5" style={{color: `${Colors.primary}`, padding: '2%'}}>Enxhi Healthineers</Typography>
          <Typography variant="h6" style={{padding: '2%'}}>
            address: rr. Myslym Shyri,<br/> 
            pall. 11/1 tirana – albania, 1010<br/>
            phone: +355699766008 <br/>
            e-mail: enxhi.hazisllari14@gmail.com <br/>
          </Typography>
        </AddressContent>
        <AddressImage src={contactImage}></AddressImage>
      </AddressContainer>
    </>
  );
}
